import { ButtonLink } from "@/components/Buttons/index";
import { useAuthUserQuery, useLoginTermsQuery } from "@/hooks";
import { GENDER_LABEL, PROFILE_MAX, profileIconImages } from "@/lib/constants";
import dayjs from "@/lib/day";
import routes from "@/lib/routes";
import styles from "@/styles/Account.module.scss";
import Image from "next/legacy/image";
import { useEffect, useMemo, useState } from "react";
import config from "@/lib/config";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AccountInfo(_ref) {
  let {
    isUid2Data
  } = _ref;
  const {
    data
  } = useAuthUserQuery({
    fetchPolicy: "cache-first"
  });
  const user = data && data.user;
  const birthday = user && user.birthday && dayjs(user.birthday).format("YYYY年MM月DD日");
  const {
    data: termsData
  } = useLoginTermsQuery({
    variables: {
      cacheMaxAge: 0
    },
    fetchPolicy: "no-cache"
  });
  const {
    0: mailOption,
    1: setMailOption
  } = useState(false);

  // ご案内メールの同意状況を取得する
  const mailTerm = useMemo(() => {
    if (termsData) {
      return termsData.optional.filter(term => {
        return term.id_key === "spoox_mail";
      });
    }
  }, [termsData]);

  // user情報から現在のoptIn状態を取得する
  const optIn = useMemo(() => {
    if (user) {
      return user.receiveAdvertisingMailType === 1;
    }
  }, [user]);

  // 取得したご案内メールの同意状況とを初期値として設定する
  useEffect(() => {
    if (termsData && user) {
      var _mailTerm$;
      const mailOptionFlag = ((_mailTerm$ = mailTerm[0]) === null || _mailTerm$ === void 0 || (_mailTerm$ = _mailTerm$.current_revision) === null || _mailTerm$ === void 0 ? void 0 : _mailTerm$.agreement) || optIn;
      const mailOptionValue = mailOptionFlag ? true : false;
      setMailOption(mailOptionValue);
    }
  }, [termsData, mailTerm, optIn]);
  return /*#__PURE__*/_jsx("div", {
    className: styles.accountInfo,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.contentsInner,
      children: [/*#__PURE__*/_jsxs("div", {
        className: `${styles.contentBox} ${styles.personalInfo}`,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.contentHeader,
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.contentTitle,
            children: "\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u60C5\u5831"
          }), /*#__PURE__*/_jsx("div", {
            className: styles.contentHeaderLink,
            children: /*#__PURE__*/_jsx(ButtonLink, {
              type: "button",
              fillLightGray: true,
              borderGray: true,
              small: true,
              fontFixed: true,
              href: config.idc.domain + config.idc.accountInfo,
              children: "\u5909\u66F4\u3059\u308B"
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.contentBody,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.contentItem,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.itemTerm,
              children: "\u540D\u524D"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.itemValue,
              children: user && user.fullName
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.contentItem,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.itemTerm,
              children: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u30ED\u30B0\u30A4\u30F3ID\uFF09"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.itemValue,
              children: user && user.mailAddress
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.contentItem,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.itemTerm,
              children: "\u30D1\u30B9\u30EF\u30FC\u30C9"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.itemValue,
              children: [/*#__PURE__*/_jsx("div", {
                children: "********"
              }), /*#__PURE__*/_jsx("div", {
                className: styles.itemLink,
                children: /*#__PURE__*/_jsx(ButtonLink, {
                  type: "button",
                  fillLightGray: true,
                  borderGray: true,
                  small: true,
                  fontFixed: true,
                  href: config.idc.domain + config.idc.passwordChange,
                  children: "\u5909\u66F4\u3059\u308B"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.contentItem,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.itemTerm,
              children: "\u751F\u5E74\u6708\u65E5"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.itemValue,
              children: birthday ? birthday : ""
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.contentItem,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.itemTerm,
              children: "\u6027\u5225"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.itemValue,
              children: user && GENDER_LABEL[user.sex]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: `${styles.contentBox} ${styles.profiles}`,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.contentHeader,
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.contentTitle,
            children: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u7BA1\u7406"
          }), /*#__PURE__*/_jsx("div", {
            className: styles.contentHeaderLink,
            children: /*#__PURE__*/_jsx(ButtonLink, {
              type: "button",
              fillLightGray: true,
              borderGray: true,
              small: true,
              fontFixed: true,
              href: routes.profileAdd,
              disabled: user && user.profiles.length >= PROFILE_MAX,
              children: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u8FFD\u52A0"
            })
          })]
        }), user && user.profiles && /*#__PURE__*/_jsx("div", {
          className: styles.contentBody,
          children: user.profiles.map((profile, idx) => {
            const icon = profile.icon;
            const path = profileIconImages[icon] || profileIconImages[1];
            const displayName = profile.displayName;
            const ownerProfile = profile.ownerProfile;
            return /*#__PURE__*/_jsxs("div", {
              className: styles.contentItem,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.itemTerm,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.profIcon,
                  children: !!path && /*#__PURE__*/_jsx(Image, {
                    src: path,
                    alt: displayName,
                    width: 64,
                    height: 64
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.profName,
                  children: [/*#__PURE__*/_jsx("div", {
                    children: profile.displayName
                  }), " ", ownerProfile && /*#__PURE__*/_jsx("div", {
                    className: styles.itemTermDescription,
                    children: "\u30AA\u30FC\u30CA\u30FC"
                  })]
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.itemLink,
                children: /*#__PURE__*/_jsx(ButtonLink, {
                  type: "button",
                  fillLightGray: true,
                  borderGray: true,
                  small: true,
                  fontFixed: true,
                  href: routes.profileEdit(profile.id),
                  children: "\u5909\u66F4\u3059\u308B"
                })
              })]
            }, idx);
          })
        })]
      }), user && termsData && /*#__PURE__*/_jsxs("div", {
        className: `${styles.contentBox} ${styles.mailOpt}`,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.contentHeader,
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.contentTitle,
            children: "\u3054\u6848\u5185\u30E1\u30FC\u30EB\u53D7\u4FE1\u8A2D\u5B9A"
          }), /*#__PURE__*/_jsx("p", {
            className: styles.contentDescription,
            children: "\u3054\u6848\u5185\u30E1\u30FC\u30EB\u53D7\u4FE1\u8A2D\u5B9A\u3092\u5909\u66F4\u3067\u304D\u307E\u3059\u3002"
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.contentBody,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.contentItem,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.itemTerm,
              children: mailOption ? "ご案内メール受信中" : "ご案内メールを受信しない"
            }), /*#__PURE__*/_jsx("div", {
              className: styles.itemLink,
              children: /*#__PURE__*/_jsx(ButtonLink, {
                type: "button",
                fillLightGray: true,
                borderGray: true,
                small: true,
                fontFixed: true,
                href: routes.mailOption,
                children: "\u5909\u66F4\u3059\u308B"
              })
            })]
          })
        })]
      }), isUid2Data && /*#__PURE__*/_jsxs("div", {
        className: `${styles.contentBox} ${styles.optout}`,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.contentHeader,
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.contentTitle,
            children: "\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u5E83\u544A\u306B\u304A\u3051\u308B\u30C7\u30FC\u30BF\u5229\u7528\u306E\u30AA\u30D7\u30C8\u30A2\u30A6\u30C8"
          }), /*#__PURE__*/_jsx("div", {
            className: styles.contentHeaderLink,
            children: /*#__PURE__*/_jsx(ButtonLink, {
              type: "button",
              className: styles.itemLink,
              borderGray: true,
              small: true,
              fontFixed: true,
              href: "https://transparentadvertising.org/",
              atagProps: {
                target: "_blank",
                rel: "noopener noreferrer"
              },
              children: "\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u5E83\u544A\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B\u3092\u5E0C\u671B\u3057\u306A\u3044"
            })
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: styles.contentDescription,
          children: "\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u60C5\u5831\u3092\u6D3B\u7528\u3057\u305F\u5E83\u544A\u914D\u4FE1\u3092\u5E0C\u671B\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u300C\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u5E83\u544A\u30B5\u30FC\u30D3\u30B9\u306E\u63D0\u4F9B\u3092\u5E0C\u671B\u3057\u306A\u3044\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3001Unified ID 2.0\u306E\u30AA\u30D7\u30C8\u30A2\u30A6\u30C8\u624B\u7D9A\u304D\u3092\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        }), /*#__PURE__*/_jsx("a", {
          target: "_blank",
          href: "https://www.skyperfectv.co.jp/policy/data/",
          className: styles.accentColoelink,
          children: "\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u5E83\u544A\u306B\u304A\u3051\u308B\u30C7\u30FC\u30BF\u5229\u7528\u306B\u3064\u3044\u3066"
        })]
      })]
    })
  });
}